import FileListController from './file.list.controller';

export default {
    controller: FileListController,
    template: require('./file.list.tpl.html')
};
